import defaultReducer from "./defaultReducer";

export default defaultReducer("FETCH_ORGANISATION_BY_POSITION", null);
